import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { 
  LinescapeEnhancesSailingScheduleswithActualTrackingData,
  LinescapeCeoToSpeakAtGlobalLinerShippingConference, 
  LinescapeJournalOfCommerceComponent, 
  SuzhouYunLogisticsTechnologySelectsLinescape, 
  LinescapeWebsiteNewLookComponent, 
  LinescapeCelebrates10thAnniversaryComponent, 
  CogoportAddsLinescapeSchedulesComponent, 
  LinescapeLaunchesSailingScheduleComponent, 
  Ef3IntegratesLinescapeDataComponent, 
  DbhIntegratesLinescapeComponent, 
  Linescape4AniversaryTranshipmentVoyageComponent, 
  XenetaAddsLinescapeComponent, 
  HavenOceanFreightMarketplaceLinescapeComponent, 
  TechStackAnniversaryComponent, 
  LinescapeUpgradesSearchEngineComponent, 
  LinescapeExhibitIntermodalEuropeComponent, 
  LinescapeMoreDataAnniversaryComponent, 
  DakosyToDistributeLinescapeComponent, 
  LinescapeCIAwardFinalistComponent, 
  DachserSelectsLinescapeSchedulesComponent, 
  LinescapeVesselInformationAnniversaryComponent, 
  LinescapeExhibitIntermodalEuropeAmsterdamComponent, 
  TransworldExpeditionShipTruckComponent, 
  LinescapeCarrierProfilesAnniversaryComponent, 
  LinescapeLaunchesOceanContainerSearchComponent, 
  LogitOneChoosesLinescapeAsSaillingScheduleProvider, 
  KotachiSelectsLinescapeSailingSchedulesApi,
  JfHillebrandToIntegrateLinescapeIntoTms,
  MercurygateAddsLinescapeToTme,
  PressRollComponent 
} from './';

const pressRoutes: Routes = [
  {
    path: '',
    component: PressRollComponent
  },
  {
    path: '',
    children: [
      { path: '2022-02-15-linescape-enhances-sailing-schedules-with-actual-tracking-data', component: LinescapeEnhancesSailingScheduleswithActualTrackingData },
      { path: '2020-09-29-linescape-ceo-to-speak-at-global-liner-shipping-conference', component: LinescapeCeoToSpeakAtGlobalLinerShippingConference },
      { path: '2020-09-14-linescape-journal-of-commerce-technology', component: LinescapeJournalOfCommerceComponent },
      { path: '2019-08-27-linescape-website-new-look', component: LinescapeWebsiteNewLookComponent },
      { path: '2019-05-10-linescape-celebrates-10th-anniversary', component: LinescapeCelebrates10thAnniversaryComponent },
      { path: '2018-12-7-cogoport-adds-linescape-schedules', component: CogoportAddsLinescapeSchedulesComponent },
      { path: '2018-8-7-cogoport-adds-linescape-schedules', component: LogitOneChoosesLinescapeAsSaillingScheduleProvider},
      { path: '2018-2-27-kotahi-selects-linescape-sailing-schedules-api', component: KotachiSelectsLinescapeSailingSchedulesApi},
      { path: '2017-11-2-linescape-launches-sailing-schedule', component: LinescapeLaunchesSailingScheduleComponent },
      { path: '2017-09-14-suzhou-yun-logistics-technology-selects-linescape', component: SuzhouYunLogisticsTechnologySelectsLinescape },
      { path: '2017-3-20-linescape-upgrades-search-engine', component: LinescapeUpgradesSearchEngineComponent },
      { path: '2016-5-6-tech-stack-anniversary', component: TechStackAnniversaryComponent },
      { path: '2016-1-25-jf-hillebrand-to-integrate-linescape-into-tms', component: JfHillebrandToIntegrateLinescapeIntoTms },
      { path: '2015-1-23-haven-ocean-freight-marketplace-linescape', component: HavenOceanFreightMarketplaceLinescapeComponent },
      { path: '2014-10-8-xeneta-adds-linescape', component: XenetaAddsLinescapeComponent },
      { path: '2014-6-4-ef3-integrates-linescape-data', component: Ef3IntegratesLinescapeDataComponent },
      { path: '2013-6-26-mercurygate-adds-linescape-to-tms', component: MercurygateAddsLinescapeToTme }, 
      { path: '2013-5-1-Linescape-4th-anniversary-transhipment-voyage', component: Linescape4AniversaryTranshipmentVoyageComponent },
      { path: '2013-1-8-dbh-integrates-linescape-schedules', component: DbhIntegratesLinescapeComponent },
      { path: '2012-11-5-dachser-selects-linescapes-sailing-schedules', component: DachserSelectsLinescapeSchedulesComponent },
      { path: '2012-7-13-linescape-ci-award-finalist', component: LinescapeCIAwardFinalistComponent },
      { path: '2012-6-14-dakosy-to-distribute-linescape', component: DakosyToDistributeLinescapeComponent },
      { path: '2012-5-3-linescape-more-data-anniversary', component: LinescapeMoreDataAnniversaryComponent },
      { path: '2011-10-24-linescape-exhibit-intermodal-europe', component: LinescapeExhibitIntermodalEuropeComponent },
      { path: '2011-5-13-linescape-vessel-information-anniversary', component: LinescapeVesselInformationAnniversaryComponent },
      { path: '2010-10-25-linescape-exhibit-intermodal-europe-amsterdam', component: LinescapeExhibitIntermodalEuropeAmsterdamComponent },
      { path: '2010-8-26-transworld-expedition-ship-truck', component: TransworldExpeditionShipTruckComponent },
      { path: '2010-5-4-linescape-carrier-profiles-anniversary', component: LinescapeCarrierProfilesAnniversaryComponent },
      { path: '2009-5-4-linescape-launches-ocean-container-search', component: LinescapeLaunchesOceanContainerSearchComponent },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(pressRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class PressRoutingModule { }



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/press-routing.module.ts